import { AnimatePresence, motion } from 'framer-motion';
import { AlertCircle, CheckCircle2, Info } from '../components/icons';
import type { ComponentType, ReactNode } from 'react';
import { useToast } from '../store/toastContext';

const Presence = AnimatePresence as ComponentType<{ children?: ReactNode }>;

export default function ToastViewport() {
  const { toasts, removeToast } = useToast();

  const iconByType = {
    success: <CheckCircle2 className="h-4 w-4" />,
    error: <AlertCircle className="h-4 w-4" />,
    info: <Info className="h-4 w-4" />
  };

  const colorByType = {
    success: 'border-green-400/40 bg-green-500/15 text-green-100',
    error: 'border-red-400/40 bg-red-500/15 text-red-100',
    info: 'border-blue-400/40 bg-blue-500/15 text-blue-100'
  };

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[120] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-2">
      <Presence>
        {toasts.map((toast) => (
          <motion.button
            key={toast.id}
            type="button"
            onClick={() => removeToast(toast.id)}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 30 }}
            className={`pointer-events-auto rounded-xl border p-3 text-left shadow-xl backdrop-blur ${colorByType[toast.type]}`}
          >
            <div className="flex items-start gap-2">
              <span className="ui-icon-chip mt-0.5">{iconByType[toast.type]}</span>
              <div>
                <p className="text-sm font-semibold">{toast.title}</p>
                {toast.description ? <p className="mt-0.5 text-xs opacity-90">{toast.description}</p> : null}
              </div>
            </div>
          </motion.button>
        ))}
      </Presence>
    </div>
  );
}
